<template>
  <!-- Einstieg „E-Mail-Empfang & Benachrichtigungen" als Briefumschlag mit Glocke
       (Kundenfeedback 15.10.2026). Sitzt in KARS-Schaden neben dem Logo –
       die Einstellungen betreffen nur KARS-Schaden, daher bewusst nicht auf
       der Willkommensseite (Kundenwunsch 15.10.2026). -->
  <v-tooltip location="bottom" :text="label">
    <template #activator="{ props: tip }">
      <button
        v-bind="tip"
        :aria-label="label"
        class="ncb"
        data-testid="notify-center-button"
        type="button"
        @click.stop="open = true"
      >
        <MailBellIcon :size="19" />
        <span v-if="showLabel" class="ncb__label">{{ $gt('E-Mail-Empfang & Benachrichtigungen') }}</span>
      </button>
    </template>
  </v-tooltip>
  <NotifyCenterDialog v-model="open" />
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue'
  import MailBellIcon from '@/components/notifyCenter/MailBellIcon.vue'
  import NotifyCenterDialog from '@/components/notifyCenter/NotifyCenterDialog.vue'
  import { gt } from '@/i18n/gt'

  withDefaults(defineProps<{ showLabel?: boolean }>(), {
    showLabel: false,
  })

  const open = ref(false)
  const label = computed(() => gt('E-Mail-Empfang & Benachrichtigungen – wer bekommt welche E-Mails?'))
</script>

<style lang="scss" scoped>
/* Dunkle App-Leiste von KARS-Schaden, neben dem Logo. */
.ncb {
  appearance: none;
  display: inline-flex; align-items: center; justify-content: center; gap: 10px;
  height: 40px; min-width: 44px; padding: 0 12px 0 10px;
  border: none; border-radius: 12px; cursor: pointer;
  font: inherit;
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.18);
  --mail-bell-ring: #1f2937;
  transition: transform var(--duration-fast, 150ms) ease, background-color var(--duration-fast, 150ms);
  &:hover { background: rgba(255, 255, 255, 0.18); }
  &:active { transform: scale(0.97); }
  &:focus-visible { outline: 2px solid #fbbf24; outline-offset: 3px; }
}
.ncb__label { font-size: 0.8rem; font-weight: 600; white-space: nowrap; }
/* Das Label braucht Platz; in schmaleren Leisten bleibt Icon + Tooltip. */
@media (max-width: 1679px) {
  .ncb__label { display: none; }
}

@media (prefers-reduced-motion: reduce) {
  .ncb { transition: none; }
}
</style>
